let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;
import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { H3 } from 'UIComponents/elements/headings';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIImage from 'UIComponents/image/UIImage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import ChecklistItem from 'pricing-pages-ui/components/common/ChecklistItem';
// @ts-expect-error svg import
import BLOB from 'bender-url!pricing-pages-ui/img/splash-page/suite-card-top-right-blob.svg';
import BestValueBadge from '../../common/BestValueBadge';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "CardLayout__StyledCardWrapper",
  componentId: "sc-1j24qfg-0"
})(["display:grid;grid-template-columns:repeat(2,auto);grid-template-areas:'header content' 'cta content' 'cta content';column-gap:24px;width:95%;padding:32px 24px;border:1px solid ", ";min-height:300px;text-align:left;margin:auto;position:relative;overflow:hidden;", ";", ";"], BATTLESHIP, breakpoint.tablet(_t || (_t = _`
    min-width: 0;
    &&& {
      margin: 0 auto;
    }

    grid-template-columns: 1fr;
    grid-template-areas:
      "header"
      "content"
      "cta";
  `)), breakpoint.phone(_t2 || (_t2 = _`
    &&& {
      width: 100%;
    }
  `)));
const StyledBlob = styled(UIImage).withConfig({
  displayName: "CardLayout__StyledBlob",
  componentId: "sc-1j24qfg-1"
})(["position:absolute;top:-1px;right:-1px;"]);
const StyledBestValueBadge = styled(BestValueBadge).withConfig({
  displayName: "CardLayout__StyledBestValueBadge",
  componentId: "sc-1j24qfg-2"
})(["position:absolute;z-index:1;top:12px;right:12px;"]);
const CardHeader = styled.div.withConfig({
  displayName: "CardLayout__CardHeader",
  componentId: "sc-1j24qfg-3"
})(["grid-area:header;max-width:700px;z-index:2;& h3{font-weight:normal;}"]);
const CTAsContainer = styled.div.withConfig({
  displayName: "CardLayout__CTAsContainer",
  componentId: "sc-1j24qfg-4"
})(["grid-area:cta;width:350px;button,a{max-width:min-content;width:100%;", "}", " ", ""], breakpoint.tablet(_t3 || (_t3 = _`
    max-width: unset;
  `)), breakpoint.tablet(_t4 || (_t4 = _`
    margin: auto;
    margin-top: 30px;
    text-align: center;
  `)), breakpoint.phoneLarge(_t5 || (_t5 = _`
    width: 100%;
  `)));
const ListContainer = styled.section.withConfig({
  displayName: "CardLayout__ListContainer",
  componentId: "sc-1j24qfg-5"
})(["grid-area:content;display:flex;flex-direction:column;"]);
const ListHeader = styled.h4.withConfig({
  displayName: "CardLayout__ListHeader",
  componentId: "sc-1j24qfg-6"
})(["font-weight:normal;font-size:0.875rem;line-height:24px;margin-bottom:18px;", ""], breakpoint.tablet(_t6 || (_t6 = _`
    margin-bottom: auto;
  `)));
const CardLayout = ({
  title,
  descriptionSubtext = null,
  bizObjectives = [],
  ctasComponent = null
}) => {
  return /*#__PURE__*/_jsxs(StyledCardWrapper, {
    children: [/*#__PURE__*/_jsx(StyledBlob, {
      src: BLOB
    }), /*#__PURE__*/_jsx(StyledBestValueBadge, {}), /*#__PURE__*/_jsxs(CardHeader, {
      children: [/*#__PURE__*/_jsx(H3, {
        "aria-level": 3,
        children: title
      }), /*#__PURE__*/_jsx("p", {
        children: descriptionSubtext
      })]
    }), /*#__PURE__*/_jsx(CTAsContainer, {
      children: ctasComponent
    }), /*#__PURE__*/_jsxs(ListContainer, {
      children: [/*#__PURE__*/_jsx(ListHeader, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "splash-page.bundles.starterCrmSuiteCard.idealFor"
        })
      }), /*#__PURE__*/_jsx(UIList, {
        className: "flex-column justify-between flex-grow-1",
        children: bizObjectives.map(bizObjectiveText => /*#__PURE__*/_jsx(ChecklistItem, {
          message: bizObjectiveText
        }, bizObjectiveText))
      })]
    })]
  });
};
export default CardLayout;